import * as React from 'react';
export const cashappafterpaySvg = React.forwardRef(
  function cashappafterpaySvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M8.67 3.828c1.336 0 2.617.504 3.454 1.195a.57.57 0 0 0 .376.13.529.529 0 0 0 .352-.143l.996-.94A.467.467 0 0 0 14 3.713a.47.47 0 0 0-.176-.347 8.05 8.05 0 0 0-2.67-1.397l.312-1.384c.067-.301-.18-.585-.51-.585H9.03a.527.527 0 0 0-.51.384l-.282 1.231C5.68 1.734 3.511 2.921 3.511 5.36c0 2.109 1.794 3.013 3.688 3.639 1.794.625 2.74.858 2.74 1.739 0 .904-.946 1.437-2.341 1.437-1.273 0-2.607-.39-3.64-1.34a.544.544 0 0 0-.731 0l-1.07.981a.472.472 0 0 0-.157.35c0 .131.06.26.16.348.834.754 1.891 1.3 3.097 1.605L4.964 15.4c-.07.3.175.584.507.586L7.398 16a.526.526 0 0 0 .515-.386l.278-1.232c3.064-.176 4.94-1.725 4.94-3.993 0-2.086-1.87-2.967-4.138-3.686-1.296-.44-2.418-.742-2.418-1.646 0-.88 1.048-1.229 2.094-1.229Z',
      }),
    );
  },
);
cashappafterpaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cashappafterpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'cashappafterpay',
  svg: cashappafterpaySvg,
};
